export default {
    data() {
        return {
            ymId: 54389293,
            ymType: 'reachGoal',
        }
    },

    methods: {
        reachGoal: function(goal) {
            if (typeof ym === "function")
                ym(this.ymId, this.ymType, goal);
        }
    },
}



// WEBPACK FOOTER //
// ./resources/js/mixins/ym.js